<template>
  <div>
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick" style="border-radius: 5px">
      <el-tab-pane label="基本信息" name="basic">
        <el-descriptions title="重要信息" direction="vertical" :column="4" border>
          <el-descriptions-item label="真实姓名" v-if="this.$store.state.CurrentUser != 'super_admin'">{{ useInfo.name }}</el-descriptions-item>
          <el-descriptions-item label="真实姓名" v-else>
            <el-row>
              <el-col :span="8">
                <el-input v-model="basicInfoForm.name" placeholder="真实姓名"></el-input>
              </el-col>
              <el-col :span="4" :offset="1">
                <el-popconfirm
                  confirm-button-text='确认'
                  cancel-button-text='取消'
                  icon="el-icon-info"
                  icon-color="red"
                  title="确认要更改当前用户的真实姓名吗？"
                  @confirm="confirmUpdateName"
                >
                  <el-button slot="reference" type="primary"><i class="el-icon-edit"></i> 更改</el-button>
                </el-popconfirm>
              </el-col>
            </el-row>
          </el-descriptions-item>
          <el-descriptions-item label="手机号码">{{ useInfo.mobile }}</el-descriptions-item>
          <el-descriptions-item label="身份证号码" :span="2" v-if="this.$store.state.CurrentUser != 'super_admin'">{{ useInfo.identity }}</el-descriptions-item>
          <el-descriptions-item label="身份证号码" :span="2" v-else>
            <el-row>
              <el-col :span="8">
                <el-input v-model="basicInfoForm.identity" placeholder="身份证号码"></el-input>
              </el-col>
              <el-col :span="4" :offset="1">
                <el-popconfirm
                  confirm-button-text='确认'
                  cancel-button-text='取消'
                  icon="el-icon-info"
                  icon-color="red"
                  title="确认要更改当前用户的身份证号码吗？"
                  @confirm="confirmUpdateIdentity"
                >
                  <el-button slot="reference" type="primary"><i class="el-icon-edit"></i> 更改</el-button>
                </el-popconfirm>
              </el-col>
            </el-row>
          </el-descriptions-item>
          <el-descriptions-item label="会员信息">
            <el-tag size="small" :type="useInfo.buy == 0 ? 'primary' : 'success'">{{
                useInfo.buy == 0 ? '非会员' : '会员'
              }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="所属团队">
            <router-link v-if="belongToTeam != null"
                         :to="{path: '/provider/details', query: {id: belongToTeam}}">
              {{ belongToTeam }}
            </router-link>
            <div v-else>不属于任何团队</div>
          </el-descriptions-item>
          <el-descriptions-item label="账户余额" v-if="this.$store.state.CurrentUser != 'super_admin'">{{ useInfo.balance }} 分</el-descriptions-item>
          <el-descriptions-item label="账户余额" v-else>
            <el-row>
              <el-col :span="8">
                <el-input v-model="balanceForm.balance" placeholder="当前账户余额"></el-input>
              </el-col>
              <el-col :span="4" :offset="1">
                <el-popconfirm
                  confirm-button-text='确认'
                  cancel-button-text='取消'
                  icon="el-icon-info"
                  icon-color="red"
                  title="确认要更改当前账户的余额吗？"
                  @confirm="confirmUpdateBalance"
                >
                  <el-button slot="reference" type="primary"><i class="el-icon-edit"></i> 更改</el-button>
                </el-popconfirm>
              </el-col>
            </el-row>

          </el-descriptions-item>
          <el-descriptions-item label="地址编号">
            {{ '省:' + useInfo.province + ', 市:' + useInfo.city + ', 区:' + useInfo.district }}
          </el-descriptions-item>
        </el-descriptions>

        <el-descriptions class="margin-top" title="其它信息" :column="4" direction="vertical" border>
          <el-descriptions-item label="昵称">{{ useInfo.nickname }}</el-descriptions-item>
          <el-descriptions-item label="直接推荐人">
            <el-row>
              <el-col :span="4" v-if="this.$store.state.CurrentUser != 'super_admin'">
                <router-link v-if="useInfo.direct > 0"
                             :to="{path: '/user/details', query: {id: useInfo.direct}}">
                  {{ useInfo.direct }}
                </router-link>
              </el-col>
              <el-col :span="12" v-else>
                <el-col :span="14">
                  <el-input v-model="recommendationForm.direct" placeholder="直接推荐人"></el-input>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-popconfirm
                    confirm-button-text='确认'
                    cancel-button-text='取消'
                    icon="el-icon-info"
                    icon-color="red"
                    title="确认要修改直接推荐人吗？"
                    @confirm="confirmUpdateDirectRecommendation"
                  >
                    <el-button slot="reference" type="primary"><i class="el-icon-edit"></i> 更改</el-button>
                  </el-popconfirm>
                </el-col>
              </el-col>
            </el-row>
          </el-descriptions-item>
          <el-descriptions-item label="间接推荐人">
            <router-link v-if="useInfo.inDirect > 0"
                         :to="{path: '/user/details', query: {id: useInfo.inDirect}}">
              {{ useInfo.inDirect }}
            </router-link>
          </el-descriptions-item>
          <el-descriptions-item label="推荐码">{{ useInfo.code }}</el-descriptions-item>
          <el-descriptions-item label="积分" v-if="this.$store.state.CurrentUser != 'super_admin'">{{ useInfo.point }}</el-descriptions-item>
          <el-descriptions-item label="积分" v-else>
            <el-row>
              <el-col :span="8">
                <el-input v-model="basicInfoForm.point" placeholder="用户积分"></el-input>
              </el-col>
              <el-col :span="4" :offset="1">
                <el-popconfirm
                  confirm-button-text='确认'
                  cancel-button-text='取消'
                  icon="el-icon-info"
                  icon-color="red"
                  title="确认要更改当前用户的积分吗？"
                  @confirm="confirmUpdatePoint"
                >
                  <el-button slot="reference" type="primary"><i class="el-icon-edit"></i> 更改</el-button>
                </el-popconfirm>
              </el-col>
            </el-row>
          </el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag size="small" :type="useInfo.status == 0 ? 'danger' : 'success'">{{
                useInfo.status == 0 ? '冻结' : '正常'
              }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="注册时间">{{ useInfo.et }}</el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>

      <el-tab-pane label="流水详情" name="income-details">
        <balance-details
          :incomes="incomes"
          :incomes-total-elements="incomesTotalElements"
          :cash-out-records="cashOutRecords"
          :cash-out-total-elements="cashOutTotalElements">
        </balance-details>
      </el-tab-pane>

      <el-tab-pane label="会员详情" name="vip-details">
        <v-i-p-info :cards="cards" :maintains="maintains"
                    :customer-id="id"
                    v-on:refresh="forceRequestCardAndMaintainInfo">
        </v-i-p-info>
      </el-tab-pane>

      <el-tab-pane label="我的代理" name="my-agents">
        <my-providers :providers="providers"></my-providers>
      </el-tab-pane>

      <el-tab-pane label="我的推广" name="my-recommendations">
        <my-recommendations
          :total-elements="recommendationsTotalElements"
          :recommendations="recommendations">
        </my-recommendations>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import * as api from "@/js/api.js"
import VIPInfo from "./vip/VIPInfo"
import MyProviders from "./my_providers/MyProviders"
import BalanceDetails from "./balance/BalanceDetails"
import MyRecommendations from "./recommendation/MyRecommendations";

export default {
  name: "UserDetails",
  components: {BalanceDetails, MyProviders, VIPInfo, MyRecommendations},
  data() {
    return {
      id: '',
      activeName: 'basic',
      useInfo: {},
      belongToTeam: null,
      incomes: [],
      incomesTotalElements: 0,

      cashOutRecords: [],
      cashOutTotalElements: 0,
      incomesRequested: false,

      cards: [],
      cardsRequested: false,

      maintains: [],
      maintainsRequested: false,

      providers: [],
      providersRequested: false,

      recommendations: [],
      recommendationsTotalElements: 0,
      recommendationsRequested: false,

      balanceForm: {
        balance: ''
      },
      recommendationForm: {
        direct: ''
      },
      basicInfoForm: {
        name: '',
        identity: '',
        point: '',
      }
    }
  },
  methods: {
    confirmUpdateDirectRecommendation() {
      const params = {
        customerId: this.id,
        direct: this.recommendationForm.direct
      }

      api.updateRecommendations(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('更新失败')
        } else {
          this.$message.success('更新成功')
          this.requestCustomerInfo()
        }
      })
    },

    confirmUpdateBalance() {
      const params = {
        customerId: this.id,
        oldBalance: this.useInfo.balance,
        newBalance: this.balanceForm.balance
      }

      api.updateBalance(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('更新失败')
        } else {
          this.$message.success('更新成功')
          this.requestCustomerInfo()
        }
      })
    },

    confirmUpdateName() {
      const params = {
        customerId: this.id,
        name: this.basicInfoForm.name,
      }
      this.updateUserBasicInfo(params)
    },

    confirmUpdateIdentity() {
      const params = {
        customerId: this.id,
        identity: this.basicInfoForm.identity,
      }
      this.updateUserBasicInfo(params)
    },

    confirmUpdatePoint() {
      const params = {
        customerId: this.id,
        point: this.basicInfoForm.point,
      }
      this.updateUserBasicInfo(params)
    },

    updateUserBasicInfo(params) {
      api.updateUserBasicInfo(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('更新失败')
        } else {
          this.$message.success('更新成功')
          this.requestCustomerInfo()
        }
      })
    },

    handleClick() {
      if (this.activeName === 'income-details') {
        this.requestIncomes()
      } else if (this.activeName === 'vip-details') {
        this.requestCardAndMaintainInfo()
      } else if (this.activeName === 'my-agents') {
        this.requestProviderInfo()
      } else if (this.activeName === 'my-recommendations') {
        this.requestRecommendations()
      }
    },

    requestIncomes() {
      if (!this.incomesRequested && this.id !== '') {
        const param = {
          customerId: this.id,
          page: 1,
          pageSize: 200,
        }
        api.userIncomes(param).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            this.incomes = result.data
            this.incomesTotalElements = this.incomes.length
          }
        })
        api.userCashOutHistories(param).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            this.cashOutRecords = result.data
            this.cashOutTotalElements = this.cashOutRecords.length
            this.incomesRequested = true
          }
        })
      }
    },

    forceRequestCardAndMaintainInfo() {
      this.cardsRequested = false
      this.maintainsRequested = false
      this.requestCardAndMaintainInfo()
    },

    requestCardAndMaintainInfo() {
      if (!this.cardsRequested && this.id !== '') {
        const param = {
          customerId: this.id,
        }
        api.userCards(param).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            this.cards = result.data
            this.cardsRequested = true
          }
        })
      }

      if (!this.maintainsRequested && this.id !== '') {
        const param = {
          customerId: this.id,
        }
        api.userMaintains(param).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            this.maintains = result.data
            this.maintainsRequested = true
          }
        })
      }
    },

    requestProviderInfo() {
      if (!this.providersRequested && this.id !== '') {
        const param = {
          customerId: this.id,
        }
        api.getProviderByCustomer(param).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            this.providers = result.data
            this.providersRequested = true
          }
        })
      }
    },

    requestRecommendations() {
      if (!this.recommendationsRequested && this.id !== '') {
        const param = {
          customerId: this.id,
          type: 1,
          pageSize: 200,
        }
        api.userPromotions(param).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            this.recommendations = result.data
            this.recommendationsTotalElements = this.recommendations.length
            this.recommendationsRequested = true
          }
        })
      }
    },

    requestCustomerInfo() {
      const params = {
        customerId: this.id
      }
      api.getUserById(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('后台服务出错');
        } else {
          this.useInfo = result.data
          this.balanceForm.balance = this.useInfo.balance
          this.basicInfoForm.name = this.useInfo.name
          this.basicInfoForm.identity = this.useInfo.identity
          this.basicInfoForm.point = this.useInfo.point
          this.recommendationForm.direct = this.useInfo.direct
        }
      })

      api.getTeamOwnerById(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('后台服务出错');
        } else {
          this.belongToTeam = result.data
        }
      })
    }
  },

  mounted() {
    this.id = this.$route.query.id
    if (this.id === undefined || this.id === null) {
      this.id = ''
    }
    if (this.id != '') {
      this.requestCustomerInfo()
    }
  },
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/users/UserDetails.vue